import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconFlexlogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "45px",
	height: "83px",
	viewBox: "0 0 107 178",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M48.1632 105.819C40.2174 105.709 32.2716 105.533 24.3294 105.515C16.2664 105.497 10.5002 102.262 8.43776 95.4444C6.25074 88.2203 7.84796 81.9156 13.0866 76.3767C33.7955 54.4771 54.292 32.3357 74.8984 10.319C81.8954 2.84204 91.3872 2.38046 97.0691 9.11005C103.418 16.6273 102.817 25.8589 95.3949 33.8084C83.7564 46.2748 72.0776 58.6973 60.4282 71.1527C59.3548 72.2993 58.373 73.5485 57.1091 75.0285C66.2639 75.1531 74.8691 75.2483 83.4743 75.3949C89.8193 75.5048 93.032 80.2452 97.6735 85.8794C101.96 91.0814 98.4758 99.1811 93.6695 104.039C87.1817 110.596 80.6059 117.044 73.1254 124.473C80.7598 132.697 87.4088 139.808 93.9992 146.977C102.879 156.637 100.934 169.833 89.9365 174.818C84.3682 177.342 78.3603 175.936 73.7774 170.803C63.4981 159.293 53.2626 147.732 43.0492 136.152C36.8215 129.092 36.8947 120.011 43.236 112.845C45.0164 110.831 46.9873 109.017 48.8703 107.109C48.6321 106.68 48.3977 106.255 48.1596 105.826L48.1632 105.819Z",
			fill: "#E5E5E5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M34.3021 121.077L80.8854 73.6293C82.4496 72.0357 84.9847 72.0357 86.5489 73.6293L102.811 90.1913C104.375 91.7849 104.375 94.3675 102.811 95.9611L56.2273 143.409C54.663 145.002 52.128 145.002 50.5637 143.409L34.3021 126.847C32.7378 125.253 32.7378 122.671 34.3021 121.077Z",
			fill: "#1d3943"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M71.6265 157.136C73.9271 148.79 82.4334 143.922 90.6283 146.266C98.8233 148.611 103.6 157.275 101.3 165.62C98.9991 173.965 90.4928 178.834 82.2978 176.489C74.1029 174.145 69.3259 165.481 71.6265 157.136Z",
			fill: "#C3D6D2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M105.851 23.5879L23.3702 107.6C21.8316 109.168 19.3405 109.168 17.8019 107.6L1.44497 90.9387C-0.0936371 89.3708 -0.0936371 86.8321 1.44497 85.2678L83.9218 1.25602C85.4605 -0.311901 87.9515 -0.311901 89.4902 1.25602L105.847 17.917C107.386 19.4849 107.386 22.0236 105.847 23.5879H105.851Z",
			fill: "#1da193"
		})
	]
});
export { SvgIconFlexlogo as ReactComponent };
